import { observe } from 'selector-observer';

import { onDocumentReady } from '@prairielearn/browser-utils';

onDocumentReady(() => {
  observe('[data-bs-toggle="tooltip"], [data-bs-toggle-tooltip="true"]', {
    add(el) {
      new window.bootstrap.Tooltip(el);
    },
    remove(el) {
      window.bootstrap.Tooltip.getInstance(el)?.dispose();
    },
  });
});
